/**
 * Het tabblad Resultaten: per leerling per les de status en de score op de
 * meerkeuzevragen ("4/5": vier goed van de vijf in zijn toets), voor alle
 * groepen of voor één. Een resultaat verwijderen
 * haalt de leerling met zijn antwoorden uit die les.
 */
import React, { useEffect, useState } from 'react';
import { Trash2 } from 'lucide-react';
import { leerkrachtApi as api } from '../../../api/leerkracht';
import { perGroep } from '../perGroep';

export function Resultaten({ actief, meldFout }) {
  const [resultaten, setResultaten] = useState([]);
  const [laden, setLaden] = useState(false);
  const [groep, setGroep] = useState(null);   // null: alle groepen

  useEffect(() => {
    if (!actief) return;
    setLaden(true);
    api.haalResultaten().then(setResultaten).catch(err => meldFout(err.message)).finally(() => setLaden(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- alleen bij het openen van het tabblad
  }, [actief]);

  const verwijder = async (id) => {
    if (!window.confirm('Weet je zeker dat je dit resultaat wilt verwijderen?')) return;
    try {
      await api.verwijderResultaat(id);
      setResultaten(await api.haalResultaten());
    } catch (err) {
      meldFout(err.message);
    }
  };

  if (laden) return <p>Laden...</p>;

  const alle = groep === null;

  return (
    <div className="card">
      <h2 className="mb-16">Resultaten</h2>

      <div style={{ marginBottom: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <button className={`btn ${alle ? 'btn-primary' : 'btn-secondary'}`} style={{ padding: '6px 12px' }} onClick={() => setGroep(null)}>
          Alle groepen ({resultaten.length})
        </button>
        {perGroep(resultaten).map(g => (
          <button key={g.class_id} className={`btn ${groep === g.class_id ? 'btn-primary' : 'btn-secondary'}`}
            style={{ padding: '6px 12px' }} onClick={() => setGroep(g.class_id)}>
            {g.class_naam} ({g.items.length})
          </button>
        ))}
      </div>

      <table>
        <thead>
          <tr>
            <th>Leerling</th>
            {alle && <th>Groep</th>}
            <th>Tekst</th>
            <th>Status</th>
            <th>MC Score</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {resultaten.filter(r => alle || r.class_id === groep).map(r => (
            <tr key={r.id}>
              <td>{r.student_naam}</td>
              {alle && <td>{r.class_naam}</td>}
              <td>{r.text_titel}</td>
              <td>
                <span className={`badge ${r.status === 'afgerond' ? 'badge-success' : 'badge-warning'}`}>{r.status}</span>
              </td>
              <td>{r.mc_score !== null ? `${r.mc_score}/${r.mc_total} (${r.mc_percentage}%)` : '-'}</td>
              <td>
                <button className="btn btn-danger" style={{ padding: '4px 8px' }} onClick={() => verwijder(r.id)}>
                  <Trash2 size={14} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
